import { createSlice } from '@reduxjs/toolkit';

export const topSellingProductsSlice = createSlice({
	name: 'topSellingProducts',
	initialState: {
		data: null,
	},
	reducers: {
		addTopSellingProducts: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { addTopSellingProducts } = topSellingProductsSlice.actions;
export default topSellingProductsSlice.reducer;
